import { BCMSRecord, useWorkflowStep } from "@bcm-dev/bcms-vite";
import { getDefaultRequest, getWorkflowSteps } from "compid/workflows/RequestEBill";
import { Biller } from "model";

import ButtonContainer from "compid/shared/containers/ButtonContainer";
import PageLayoutContainer from "compid/shared/containers/PageLayoutContainer";
import CenterColumnContainer from "compid/shared/containers/PageLayoutContainer/containers/CenterColumnContainer";
import PageView from "compid/shared/containers/PageViewContainer";
import BillerView from "compid/shared/views/BillerView";
import UIButton from "compid/ui/UIButton";
import { SVGAsset } from "res";
import "./styles.css";

export default function ConfirmEBillPage(props) {
    // Initalize the workflowStep and set globalController for the Biller class
    const workflowStep = useWorkflowStep(getDefaultRequest, getWorkflowSteps);
    BCMSRecord.globalControllerFor([ Biller ], workflowStep.globalController);

    const biller = workflowStep.read("biller");
    const navigate = workflowStep.navigate;

    return (
        <PageView className="confirm-ebill-page">
            <p className="page-sub-header semi-bold-text">EBILL CONFIRMATION</p>

            <PageLayoutContainer>
                <div className="flex-container flex-vertical flex-width">
                    <div className="flex-height flex-container flex-vertical upper-content-container">
                        <BillerView biller={ biller } />
                    </div>
                    
                    <div className="flex-height flex-width flex-container all-center">
                        <CenterColumnContainer>

                            <div className="flex-container flex-vertical">
                                <div className="flex-height flex-container flex-vertical all-center">
                                    <SVGAsset id="CheckmarkIcon" className="green-icon" />
                                    <b className="gray-text">Your eBill has been requested</b>
                                </div>
                                <div className="flex-height">
                                    <p className="text-left">We'll switch you from paper bills to eBills once you've been activiated and received your first eBill (usually within 1-2 billing cycles.)</p>
                                    <p className="text-left">Until then continue to pay your paper bills. </p>
                                </div>
                            </div>
                            <ButtonContainer className="flex-height form-button-container">
                              <UIButton className="secondary-button" onClick={ () => navigate(`/billerDetails/details/${ biller.id }`) } 
                              dataPoint="Go_To_Biller_Details_Button">Go to biller details</UIButton>
                              <UIButton className="primary-button" onClick={ () => navigate("/payBills") }>Go to Pay Bills</UIButton>
                            </ButtonContainer>
                        </CenterColumnContainer>
                    </div>
                </div>
            </PageLayoutContainer>
        </PageView>
    );
}